import imageCompression from 'browser-image-compression';

export default {
    /**
     * refer  - https://www.npmjs.com/package/browser-image-compression
     *  you should provide one of maxSizeMB, maxWidthOrHeight in the options
        const options = { 
        maxSizeMB: number,          // (default: Number.POSITIVE_INFINITY)
        maxWidthOrHeight: number,   // compressedFile will scale down by ratio to a point that width or height is smaller than maxWidthOrHeight (default: undefined)
        useWebWorker: boolean,      // optional, use multi-thread web worker, fallback to run in main-thread (default: true)
        maxIteration: number,       // optional, max number of iteration to compress the image (default: 10)
        exifOrientation: number,    // optional, see https://stackoverflow.com/a/32490603/10395024
        onProgress: Function,       // optional, a function takes one progress argument (percentage from 0 to 100) 
        fileType: string            // optional, fileType override
        }
     * @param {*} imageFile 
     * @param {*} options 
     * @returns compressed file
     */
    compressSingleImageFile(imageFile,options) {
        if(options==undefined || options == null){
            let defaultOptions = {
                maxSizeMB : .3,
                maxWidthOrHeight : 1920
            }
            return imageCompression(imageFile, defaultOptions)
        }else{
            return imageCompression(imageFile, options)
        }
    },

    compressMultipleFiles(files) {
        return new Promise(resolve => {
            let compressedFiles = [];
            let totalFiles = files.length;
            for (let index = 0; index < totalFiles ; index++) {
                const file = files[index];
                this.compressSingleImageFile(file).then(compressedFile => {
                  compressedFiles.push(compressedFile);
                  if(index == totalFiles-1){
                      resolve(compressedFiles);
                  }
                });
              }
        })
    },

    checkIfValidImageFiles(files){
        const validImageTypes = ['image/gif', 'image/jpeg', 'image/png'];
        for (let index = 0; index < files.length ; index++) {
            const file = files[index];
            if (!validImageTypes.includes(file.type)) {//invalid image
                return false;
            }
        }
        return true;
    }
  }